const TOOLTIP_MAX_WIDTH = 320;
const TOOLTIP_MIN_HEIGHT = 64;
const VIEWPORT_MARGIN = 8;
function placeAlongAxis(cursor, size, viewportSize) {
    if (cursor + size <= viewportSize - VIEWPORT_MARGIN) {
        return { start: Math.max(cursor, VIEWPORT_MARGIN), end: null };
    }
    if (cursor - size >= VIEWPORT_MARGIN) {
        return {
            start: null,
            end: Math.max(viewportSize - cursor, VIEWPORT_MARGIN),
        };
    }
    return {
        start: Math.max(VIEWPORT_MARGIN, viewportSize - size - VIEWPORT_MARGIN),
        end: null,
    };
}
export function calculateTooltipPosition(tooltipEl, cursorPosition) {
    const tooltipRect = tooltipEl ? tooltipEl.getBoundingClientRect() : null;
    const tooltipWidth = tooltipRect?.width || TOOLTIP_MAX_WIDTH;
    const tooltipHeight = tooltipRect?.height || TOOLTIP_MIN_HEIGHT;
    const horizontal = placeAlongAxis(cursorPosition[0], tooltipWidth, window.innerWidth);
    const vertical = placeAlongAxis(cursorPosition[1], tooltipHeight, window.innerHeight);
    return {
        top: vertical.start,
        left: horizontal.start,
        bottom: vertical.end,
        right: horizontal.end,
    };
}
//# sourceMappingURL=tooltip.js.map